var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("q-page", { attrs: { padding: "" } }, [
    _c(
      "div",
      { staticClass: "q-display-1 q-mb-md text-secondary" },
      [
        _c("q-icon", {
          staticClass: "q-mb-sm",
          attrs: { name: "far fa-calendar-alt" }
        }),
        _vm._v(" " + _vm._s(_vm.$t("appointment_types")) + "\n    ")
      ],
      1
    ),
    _c("div", { staticClass: "row gutter-sm" }, [
      _c(
        "div",
        { staticClass: "col-12" },
        [
          _c(
            "q-field",
            { attrs: { count: 256 } },
            [
              _c("q-input", {
                attrs: {
                  "float-label": _vm.$t("title"),
                  error: _vm.$v.title.$error
                },
                on: { input: _vm.$v.title.$touch },
                model: {
                  value: _vm.title,
                  callback: function($$v) {
                    _vm.title = $$v
                  },
                  expression: "title"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "col-12" },
        [
          _c(
            "q-field",
            { attrs: { count: 1024 } },
            [
              _c("q-input", {
                attrs: {
                  type: "textarea",
                  error: _vm.$v.description.$error,
                  "float-label": _vm.$t("description")
                },
                on: { input: _vm.$v.description.$touch },
                model: {
                  value: _vm.description,
                  callback: function($$v) {
                    _vm.description = $$v
                  },
                  expression: "description"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "col-12" },
        [
          _c("q-input", {
            attrs: {
              type: "number",
              "float-label": _vm.$t("individual_value"),
              prefix: "$",
              decimals: 2
            },
            on: { input: _vm.changeToDecimal },
            model: {
              value: _vm.individual_value,
              callback: function($$v) {
                _vm.individual_value = $$v
              },
              expression: "individual_value"
            }
          })
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "col-12" },
        [
          _c("q-input", {
            attrs: {
              type: "number",
              "float-label": _vm.$t("minimum_participants")
            },
            model: {
              value: _vm.mininum_participants_qty,
              callback: function($$v) {
                _vm.mininum_participants_qty = $$v
              },
              expression: "mininum_participants_qty"
            }
          })
        ],
        1
      ),
      _vm.qty_presential_events > 0
        ? _c(
            "div",
            { staticClass: "col-12" },
            [
              _c(
                "q-alert",
                {
                  staticClass: "full-width",
                  attrs: { color: "negative", icon: "fas fa-exclamation" }
                },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(
                        _vm.$t(
                          "this_type_of_class_is_being_used_in_events_changing_the_maximum_number_of_participants_will_change_the_maximum_number_of_participants_in_the_events_where_it_is_being_used"
                        )
                      ) +
                      "\n            "
                  )
                ]
              )
            ],
            1
          )
        : _vm._e(),
      _c(
        "div",
        { staticClass: "col-12" },
        [
          _c("q-input", {
            attrs: {
              type: "number",
              "float-label": _vm.$t("maximum_participants")
            },
            model: {
              value: _vm.maximum_participants_qty,
              callback: function($$v) {
                _vm.maximum_participants_qty = $$v
              },
              expression: "maximum_participants_qty"
            }
          })
        ],
        1
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: false,
              expression: "false"
            }
          ],
          staticClass: "col-12"
        },
        [
          _c("q-select", {
            attrs: {
              options: _vm.areas,
              "float-label": _vm.$t("areas"),
              error: _vm.$v.area.$error,
              multiple: "",
              chips: ""
            },
            on: { input: _vm.$v.area.$touch },
            model: {
              value: _vm.area,
              callback: function($$v) {
                _vm.area = $$v
              },
              expression: "area"
            }
          })
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "col-12" },
        [
          _c("p", { staticClass: "caption" }, [
            _vm._v(_vm._s(_vm.$t("status")))
          ]),
          _c("q-btn-toggle", {
            attrs: {
              "toggle-color": _vm.getColorStatus,
              options: _vm.status_list
            },
            model: {
              value: _vm.status,
              callback: function($$v) {
                _vm.status = $$v
              },
              expression: "status"
            }
          })
        ],
        1
      )
    ]),
    _c("div", { staticClass: "row gutter-sm justify-end q-mt-lg" }, [
      _c(
        "div",
        { staticClass: "col-xs-12 col-sm-3", class: _vm.getOrder("cancel") },
        [
          _c("q-btn", {
            staticClass: "full-width",
            attrs: {
              color: "tertiary",
              label: _vm.$t("back"),
              icon: "fas fa-chevron-left"
            },
            on: {
              click: function($event) {
                return _vm.$router.push({ name: "appointment_types" })
              }
            }
          })
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "col-xs-12 col-sm-3", class: _vm.getOrder("save") },
        [
          _c("q-btn", {
            staticClass: "full-width",
            attrs: {
              color: "secondary",
              label: _vm.$t("save"),
              icon: "far fa-save"
            },
            on: {
              click: function($event) {
                return _vm.saveData()
              }
            }
          })
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }